
(function ($) {
  window.$ = $;

  //reset filters on footer, nav link
  $('body').on('click', '.nav a', ()=>{
    Cookies.remove('service', { path: '/'});
    Cookies.remove('floors', { path: '/'});
    Cookies.remove('category', { path: '/'});
  });
  $('body').on('click', 'footer a', ()=>{
    Cookies.remove('service', { path: '/'});
    Cookies.remove('floors', { path: '/'});
    Cookies.remove('category', { path: '/'});
  });
  $('body').on('click', '.services-item__btn', ()=>{
    Cookies.remove('service', { path: '/'});
    Cookies.remove('floors', { path: '/'});
    Cookies.remove('category', { path: '/'});
  });

  let height = $('.floors__map').outerHeight(true);
  $('.floors').css('height', height);

  $(window).on('resize', function () {
    let height = $('.floors__map').outerHeight(true);
    $('.floors').css('height', height);
  });

  // alert trigger
  $('.js-alert-close').on('click', function () {
    let alert = $('.js-alert');
    let alertHeight = alert.outerHeight() * -1;
    alert.css('margin-top', alertHeight)
    Cookies.set('alert', 1, {
      path: '/'
    });
  });

  // nav trigger
  $('.js-nav').on('click', function () {
    $('.js-nav').toggleClass('is-active');
    $('.logo-nav').toggleClass('is-active');
    //disable scroll when nav menu is active
    disableScroll('body');
  });

  $(document).ready(function () {

    //restore default heights o mobile
    $(window).on('resize load', function () {
      let windowWidth = $(this).width();
      if (theme.current_page_id != 404) {
        detectTwoColumnDifference($('[data-scroll="content"]'), windowWidth)
      }
    })

    $('body').addClass('visible');

    new WOW({
      offset: 70,
      mobile: false,
    }).init();

  });


  $('.module-link .module-description').on('hover', function () {
    $(this).siblings('.module-image').children('img').css('transform', 'scale(1.05)');
  });

  $('.module-link .module-description').off('hover', function () {
    $(this).siblings('.module-image').children('img').css('transform', 'scale(1)');
  });

  let tab = window.location.search;

})(jQuery);

function detectTwoColumnDifference(scrollContent) {
  let columnsDiffrence = [];
  let columnsDiffrenceResult;
  let elements = {};

  if(scrollContent.length == 0) {
    return;
  }

  scrollContent.each(function (i, e) {
    let height = $(this).outerHeight(true);
    elements[i] = {};
    elements[i].el = $(e);
    elements[i].height = height;
    columnsDiffrence.push(height);
  });

  columnsDiffrence.sort((a, b) => a - b);
  columnsDiffrenceResult = columnsDiffrence[1] - columnsDiffrence[0];

  let widowHeight = $(window).height();
  let newHeight = columnsDiffrence[0] - widowHeight

  elements[0].height > elements[1].height ? elements[1].el[0].style.top = `-${newHeight}px` : elements[0].el[0].style.top = `-${newHeight}px`;
}

$(window).on('load resize', function(){
  if (theme.current_page_id != 404) {
    detectTwoColumnDifference($('[data-scroll]'));
  } 
});


function disableScroll(el) {
  if (!$(`${el}`).hasClass('stop-scroll')) {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    $(`${el}`).addClass('stop-scroll');
    window.onscroll = function () {
      window.scrollTo(scrollLeft, scrollTop);
    };
  } else {
    window.onscroll = function () {};
    $(`${el}`).removeClass('stop-scroll');
  }
}


